export default __webpack_public_path__ + "static/media/sn.1f893f16.jpg";